import { store as auth } from '@/modules/auth'
import { store as usuarios } from '@/modules/usuarios'
import { store as pagination } from '@/modules/pagination'
import { store as configuracoes } from '@/modules/configuracoes'
import { store as escritorios } from '@/modules/escritorios'
import { store as carrinho } from '@/modules/carrinho'
import { store as formaspagamento } from '@/modules/formasPagamento'
import { store as recursosdisponiveis } from '@/modules/recursosDisponiveis'
import { store as filtros } from '@/modules/filtros'
import { store as emitentes } from '@/modules/emitentes'
import { store as politicaSeguranca } from '@/modules/politicaSeguranca'
import { store as gestaoProdutos } from '@/modules/gestaoProdutos'

export default {
  auth,
  usuarios,
  pagination,
  configuracoes,
  escritorios,
  carrinho,
  formaspagamento,
  recursosdisponiveis,
  filtros,
  emitentes,
  politicaSeguranca,
  gestaoProdutos
}
